export default {
	firebase: {
		apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    	projectId:  process.env.VUE_APP_FIREBASE_PROJECT_ID,
	    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
		messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID
	}
}